// src/components/Jobs/JobFormCauris.js
import React, { useState, useEffect, useContext } from "react";
import { Form, Button } from "react-bootstrap";
import { forms } from "../../styles/theme";
import axios from "axios";
import { UserContext } from "../../contexts/UserContext";
import Select from "react-select";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
import { getPipelineByCode } from "../../config/pipelines";

const JobFormCauris = ({ onSubmit, code, user_id }) => {
  const [jobName, setJobName] = useState("");
  const [baseSpaceName, setbaseSpaceName] = useState("");
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { user } = useContext(UserContext);

  const pipeline = getPipelineByCode(code);



  // 🔹 Fetch projects from backend
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/basespace/projects`, {
          params: { userId: user?.id } // ✅ pass userId here
        });
        // Sort newest first (assuming project has `DateCreated` or similar)
        const sorted = [...res.data.projects].sort(
          (a, b) => new Date(b.DateCreated) - new Date(a.DateCreated)
        );
        setProjects(sorted);
      } catch (err) {
        console.error("Error fetching BaseSpace projects:", err);
      }
    };
    fetchProjects();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!jobName || !user_id || !baseSpaceName) return; // ⚡ guard

    setLoading(true);
    setError(null);
    setSuccess(null);

    const jobPayload = {
      name: jobName,
      code,
      user_id,
      baseSpaceName,
      pipeline_id: pipeline?.id

    };

    // console.log("Submitting jobPayload:", jobPayload);

    try {
      // const response = await axios.post(`${API_BASE_URL}/api/jobs/createcauris`, jobPayload);

      const endpoint = pipeline?.apiEndpoint || '/api/jobs/createcauris';
      const response = await axios.post(`${API_BASE_URL}${endpoint}`, jobPayload);


      if (onSubmit) onSubmit(response.data);

      setJobName("");
      setbaseSpaceName("");
      setSuccess("Job submitted successfully!");
    } catch (err) {
      console.error("Error submitting job:", err);
      setError("Failed to submit job.");
    } finally {
      setLoading(false);
    }

  };


  return (
    <Form onSubmit={handleSubmit}>

      {/* 显示状态信息 */}
      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      {/* Dynamic code name */}
      <Form.Group controlId="code" style={forms.group}>
        <Form.Label style={forms.label}>Data</Form.Label>
        <Form.Control type="text" 
          value={pipeline?.data || code} 
          readOnly style={forms.control} 
        />
      </Form.Group>

      {/* // Inside your component's return() instead of the old filter + dropdown */}
      <Form.Group controlId="baseSpaceName" style={forms.group}>
        <Form.Label style={forms.label}>BaseSpace Project</Form.Label>

        <Select
          options={projects.map((p) => ({ value: p.Name, label: p.Name }))}
          value={baseSpaceName ? { value: baseSpaceName, label: baseSpaceName } : null}
          onChange={(option) => {
            setbaseSpaceName(option.value);
            if (!jobName) setJobName(option.value); // auto-fill jobName
          }}
          placeholder="Type to search projects"
          isSearchable
          styles={{
            control: (base) => ({ ...base, minHeight: "38px" }), // optional styling
          }}
        />
      </Form.Group>

      {/* Job Name */}
      <Form.Group controlId="jobName" style={forms.group}>
        <Form.Label style={forms.label}>Job Tag</Form.Label>
        <Form.Control
          type="text"
          value={jobName}
          onChange={(e) => setJobName(e.target.value)}
          placeholder="Job name"
          style={forms.control}
        />
      </Form.Group>


     

      <Button variant="primary" type="submit" style={forms.button}>
        Submit Job
      </Button>
    </Form>
  );
};

export default JobFormCauris;
